export default __webpack_public_path__ + "static/media/RentbackHouse.f277ccc3.svg";